import React, { Component } from 'react';
import {
  BarChart,
  Bar,
  Brush,
  Cell,
  CartesianGrid,
  ReferenceLine,
  ReferenceDot,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ErrorBar,
  LabelList
} from 'recharts';
import { scaleOrdinal } from 'd3-scale';
//import { schemeCategory10 } from 'd3-scale-chromatic';
import _ from 'lodash';

//const colors = scaleOrdinal(schemeCategory10).range();

const record = d => [
  { name: 'Imported', amt: d.number_of_games_created_by_import },
  { name: 'Template', amt: d.number_of_games_created_by_template },
  { name: 'Sponsored', amt: d.number_of_games_created_by_sponsor },
  {
    name: 'From Scratch',
    amt:
      d.number_of_games_created -
      (d.number_of_games_created_by_sponsor +
        d.number_of_games_created_by_template +
        d.number_of_games_created_by_import)
  },
  { name: 'Shared', amt: d.number_of_games_shared_by_colleague }
];

class BBarChart extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var self = this;
    var data = self.props.record;
    return (
      <div>
        <BarChart width={570} height={260} data={record(data)}>
          <XAxis dataKey="name" />
          <YAxis yAxisId="a" />
          <Legend layout="vertical" align="bottom" verticalAlign="bottom" />
          <Tooltip />
          <CartesianGrid vertical={false} />
          <Bar yAxisId="a" dataKey="amt">
            <LabelList fontSize={10} fill="#fff" angle={-45} />
            <LabelList
              position="top"
              fontSize={13}
              offset={10}
              fill="#000"
              angle={-45}
            />

            {record(data).map((entry, index) => (
              <Cell key={`cell-${index}`} fill={'#d81b60'} />
            ))}
          </Bar>
        </BarChart>
      </div>
    );
  }
}

export default BBarChart;



// WEBPACK FOOTER //
// ./src/users/BarChart.js